<template>

    <div>
        <h4 class="mb-6">Multicast Nodes</h4>

        <vs-button color="success" icon-pack="feather" icon="icon-plus-circle" class="mb-3" @click="addNodePrompt = true">Add</vs-button>

        <vx-card>
            <vs-table id="table" ref="table" @selected="openNode" pagination :max-items="itemsPerPage" search :data="tableData">

                <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">

                    <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4" v-if="tableData.length > 0">
                        <div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
                            <span class="mr-2">{{ currentPage * itemsPerPage - (itemsPerPage - 1) }} - {{ tableData.length - currentPage * itemsPerPage > 0 ? currentPage * itemsPerPage : tableData.length }} of {{ tableData.length }}</span>
                            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
                        </div>

                        <vs-dropdown-menu>

                            <vs-dropdown-item @click="itemsPerPage=10">
                                <span>10</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item @click="itemsPerPage=20">
                                <span>20</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item @click="itemsPerPage=50">
                                <span>50</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item @click="itemsPerPage=100">
                                <span>100</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item @click="itemsPerPage=250">
                                <span>250</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item @click="itemsPerPage=500">
                                <span>500</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item @click="itemsPerPage=1000">
                                <span>1000</span>
                            </vs-dropdown-item>
                        </vs-dropdown-menu>
                    </vs-dropdown>
                </div>

                <template slot="thead">
                    <vs-th sort-key="name">Name</vs-th>
                </template>

                <template slot-scope="{data}">
                    <tbody>
                        <vs-tr :data="tr" :key="index" v-for="(tr, index) in data">

                            <vs-td :data="data[index].name">
                                {{ data[index].name }}
                            </vs-td>

                        </vs-tr>
                    </tbody>
                </template>

            </vs-table>
        </vx-card>

        <vs-popup title="Add Multicast Node" :active.sync="addNodePrompt">
            <div id="addNodeDiv" class="vs-con-loading__container" >
                <p class="mt-6">Name</p>
                <vs-input v-model="addObject['name']" class="w-full"></vs-input>
                <vs-divider/>
                <vs-button color="success" class="mt-6; mr-1" @click="addNode">Add</vs-button>
            </div>
        </vs-popup>

    </div>

</template>
<script>

    export default {

        data() {
            return {

                itemsPerPage: 100,
                isMounted: false,

                nodes: [],

                addNodePrompt: false,
                addObject: {}

            }
        },
        methods: {
            loadData() {
                this.$vs.loading({
                    container: '#table',
                    type: 'corners',
                    scale: 0.7
                })

                const thisIns = this
                const loadPromise = this.$http.get('/api/management/v1/multicast_node/')
                loadPromise.then(function(response) {
                    thisIns.nodes = response.data
                }).catch(function(error) {
                    thisIns.$printError(error.response.data)
                }).finally(function() {
                    thisIns.$vs.loading.close('#table > .con-vs-loading')
                })
            },
            addNode() {
                this.$vs.loading({
                    container: '#addNodeDiv',
                    type: 'corners',
                    scale: 0.7
                })

                const thisIns = this

                const addPromise = this.$http.post('/api/management/v1/multicast_node/', {
                    name: this.addObject.name
                })

                addPromise.then(function() {
                    thisIns.addNodePrompt = false
                    thisIns.$printSuccess('Multicast node added')
                    thisIns.$nextTick(() => {
                        thisIns.loadData()
                    })
                }).catch(function(error) {
                    thisIns.$printError(error.response.data)
                }).finally(function() {
                    thisIns.$vs.loading.close('#addNodeDiv > .con-vs-loading')
                })
            },
            openNode(tr) {
                this.$router.push('/multicast_node/' + tr.id)
            }
        },
        computed: {
            currentPage() {
                if (this.isMounted) {
                    return this.$refs.table.currentx
                }
                return 0
            },
            tableData() {
                return this.nodes
            }
        },
        mounted() {
            this.isMounted = true
            this.loadData()
        },
        beforeRouteLeave(to, from, next) {
            if (this.addNodePrompt) {
                this.addNodePrompt = false
                next(false)
            } else {
                next()
            }
        }

    }

</script>
